// src/services/financeIncomesService.js
import { fetchWithAuth } from '../utils/fetchWithAuth';

const enc = (v) => encodeURIComponent(String(v ?? ''));
const qstr = (params = {}) =>
  new URLSearchParams(
    Object.entries(params).filter(([, v]) => v != null && v !== '')
  ).toString();

/* =============== Conceptos =============== */
export const listIncomeConcepts = async (rut) => {
  const qs = rut && rut !== '*' ? `?rut=${enc(rut)}` : '';
  // backend: GET /finance/incomes/concepts/list
  const res = await fetchWithAuth(`/finance/incomes/concepts/list${qs}`, { method: 'GET' });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
};

export const upsertIncomeConcept = async ({ rut, code, name, active = true }) => {
  // backend: POST /finance/incomes/concepts/upsert
  const res = await fetchWithAuth(`/finance/incomes/concepts/upsert`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ rut, code, name, active }),
  });
  if (!res.ok) {
    const e = await res.json().catch(() => ({}));
    throw new Error(e.message || `HTTP ${res.status}`);
  }
  return res.json();
};

/* =============== Ingresos (CRUD) =============== */
export const listIncomes = async (params = {}) => {
  const qs = qstr(params);
  const url = `/finance/incomes${qs ? `?${qs}` : ''}`;
  const res = await fetchWithAuth(url, { method: 'GET' });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
};

export const createIncome = async (payload) => {
  const res = await fetchWithAuth(`/finance/incomes`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const e = await res.json().catch(() => ({}));
    throw new Error(e.message || `HTTP ${res.status}`);
  }
  return res.json();
};

export const updateIncome = async (id, payload) => {
  const res = await fetchWithAuth(`/finance/incomes/${enc(id)}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const e = await res.json().catch(() => ({}));
    throw new Error(e.message || `HTTP ${res.status}`);
  }
  return res.json();
};

export const deleteIncome = async (id) => {
  const res = await fetchWithAuth(`/finance/incomes/${enc(id)}`, { method: 'DELETE' });
  if (!res.ok) {
    const e = await res.json().catch(() => ({}));
    throw new Error(e.message || `HTTP ${res.status}`);
  }
  return res.json();
};

/* =============== Desde Pago (auto-registro) =============== */
export const createIncomeFromPayment = async (paymentId, opts) => {
  // El backend hoy ignora splits y siempre registra CUOTA_SOCIAL.
  const body = { paymentId: Number(paymentId) };
  // (robusto) si algún día vuelves a usar splits, soporta array u objeto:
  if (Array.isArray(opts)) body.overrideConceptSplits = opts;
  else if (opts && Array.isArray(opts.overrideConceptSplits)) body.overrideConceptSplits = opts.overrideConceptSplits;

  const res = await fetchWithAuth(`/finance/incomes/from-payment`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const e = await res.json().catch(() => ({}));
    throw new Error(e.message || `HTTP ${res.status}`);
  }
  return res.json();
};
